<template>
  <div class="store">
    <SiruiSearch
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      :defaultRow="2"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></SiruiSearch>
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :showFooter="true"
        :footerMethod="footerMethod"
        :loading="loadingTable"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="seq"
          width="50"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <span v-if="item.field === 'expenseType'">
              {{
                dictListMap.LeaseContractExpenseName.find(
                  (item) => item.value == row['expenseType']
                )?.label
              }}
            </span>
            <span v-else-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</span>
            <span v-else-if="item.field === 'businessCategory'">{{
              dictListMap?.businessCategoryPayable.find(
                (item) => item.value == row['businessCategory']
              )?.label
            }}</span>
            <span v-else-if="item.field === 'unit'">{{
              dictListMap?.LeaseContractChargeUnit.find((item) => item.value == row['unit'])?.label
            }}</span>
            <span v-else-if="item.field === 'spaceType'">{{
              dictListMap?.LeaseContractSpaceType.find((item) => item.value == row['spaceType'])
                ?.label
            }}</span>
            <span v-else-if="item.field === 'spaceCategory'">{{
              dictListMap?.LeaseContractSpaceCategory.find(
                (item) => item.value == row['spaceCategory']
              )?.label
            }}</span>

            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
  </div>
</template>

<script>
  import { searchColumns, defaultTableColumn, defaultMenuBtnList } from './index.js';
  import leaseContractApi from '@/api/receivablesAndPayables/leaseContract.js';
  import BASE_API from '@/api/dataBase';
  export default {
    name: 'supervisionSheet',
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      // console.log("ctx.dictListMap?.LeaseContractExpenseName",this.dictListMap?.LeaseContractExpenseName)
      this.getTableData();
      this.getButtonList();
      this.$nextTick(() => {
        this._getCompanyApi();
      });
      this.expenseTypeList = this.dictListMap?.expenseType;
      this.query.businessCategory = '04';
    },
    data() {
      return {
        loadingTable: false,
        query: {
          storageCode: '',
          storageName: '',
          createBy: '',
        },
        forbidden: true, // 是否禁用
        sellForbid: true,
        purchaseForbid: true,
        sellSubjectRule: [], // 销售数据对账科目校验规则
        purchaseSubjectRule: [], // 采购数据对账科目校验规则
        subjectList: [], // 对账科目销售
        subjectProcureList: [], //采购
        idList: [],
        reason: null,
        handleRejectValue: '',
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        partnerTypeData: {}, // 合作伙伴类型 => 用于表格回显
        requestStatusData: {}, // 状态 => 用于表格回显
        partnerTypeList: [], // 合作伙伴类型下拉
        requestStatusList: [], // 状态下拉
        importUrl: '',
        importData: {},
        columnList: [],
        companyList: [],
        departmentList: [], //部门列表
        expenseTypeList: [],
      };
    },
    methods: {
      footerMethod({ columns }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (columnIndex === 3) {
              return `原币结算金额（含税） `;
            } else if (columnIndex === 5) {
              return `本币结算金额（含税）`;
            }
            return null;
          }),
        ];
      },
      // 计算选中金额
      _computedAmount(selection) {
        console.log('selection', selection);
        const originalAmount = selection.reduce((prev, cur) => prev + cur.originalAmount, 0);
        const domesticAmount = selection.reduce((prev, cur) => prev + cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom1 = allTdDom[4];
        const totalDom2 = allTdDom[6];
        totalDom1.querySelector('.vxe-cell').innerHTML = originalAmount.toFixed(2);
        totalDom2.querySelector('.vxe-cell').innerHTML = domesticAmount.toFixed(2);
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e.length > 0 ? e : defaultMenuBtnList;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn).then(() => {
          this.columnList = defaultTableColumn;
        });
      },
      // 获取表格数据
      getTableData() {
        this.loadingTable = true;
        const createMethodMap = {
          '01': '系统',
          '02': '手动',
        };
        const postData = {
          ...this.query,
          businessCategory: '04',
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
          businessGroup: this.userInfo.businessGroup,
        };
        this.$axios.post(`${leaseContractApi.GET_PAGE_TABLE}`, postData).then((res) => {
          console.log(res, '结果');
          this.loadingTable = false;
          if (res.data.code === 0) {
            let data = res.data.data.records.map((item) => {
              return {
                ...item,
                createMethod: createMethodMap[item.createMethod],
              };
            });
            this.tableData = Object.freeze(data);

            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      // 表格上面的按钮
      chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type === 'create') {
          this.createHandler();
        } else if (type === 'export') {
          this.exportFileHandler();
        }
      },
      // 创建结算单
      createHandler() {
        if (this.multipleSelection.length < 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '您还没有选择数据',
          });
          return;
        }
        if ([...new Set(this.multipleSelection.map((item) => item.contractNo))].length > 1) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '您选择的2个合同号不一样',
          });
          return;
        }
        // 判断当前是否选中了已经处理的单
        if (
          !this.multipleSelection.map((item) => item.processStatus).every((item) => item == '0')
        ) {
          this.$message({
            showClose: false,
            type: 'warning',
            message: '请选择未处理的单',
          });
          return;
        }
        // TODO 判断两个合同是否一致
        const idList = this.multipleSelection.map((item) => item.id);
        let path = {
          path: '/receivablesAndPayables/leaseContractDetail',
          name: 'leaseContractDetail',
          meta: {
            keepAlive: true,
            title: '三方租赁应付结算单创建',
          },
          query: {
            status: 'create',
            id: idList,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      async exportFileHandler() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请选择要导出的数据');
          return;
        }
        const ids = this.multipleSelection.map((item) => item.id);
        const { data } = await this.$axios.post(leaseContractApi.EXPORT_EXCEL, {
          ids,
          businessCategory: this.query?.businessCategory,
        });
        if (data.code === 0) {
          window.location.href = data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
        this._computedAmount(row);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this._computedAmount([]);
        this.getTableData(true);
      },
      // 重置
      resetBtnClickHandler() {
        console.log('重置');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.idList = [];
        this._computedAmount([]);
        console.log('this.query.businessDepartmentCode', this.query.businessDepartmentCode);
        this.query = {
          ...this.query,
          businessCompanyNo: this.userInfo.companyCode,
          businessCompanyName: this.userInfo.companyName,
          businessDepartmentCode: this.userInfo?.departmentCode,
          businessDepartmentName: this.userInfo?.departmentName,
        };
        this.getTableData(true);
        // this.getTableData(true);
      },
      // 获取公司
      async _getCompanyApi() {
        // console.log('开始获取公司', this.userInfo);
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        if (data.code == 0) {
          // console.log(data.data, '???=====》》');
          this.companyList = data.data?.personCompanyInfo;
          // console.log(this.companyList, 'companyList');
          // console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

          if (!this.userInfo.companyCode) {
            // console.log('非userInfo');
            const companyCode = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyCode
              : null;
            const companyName = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyName
              : null;
            this.query = {
              ...this.query,
              businessCompanyNo: companyCode,
              businessCompanyName: companyName,
            };
          } else {
            // console.log('userInfo');
            this.query = {
              ...this.query,
              businessCompanyNo: this.userInfo.companyCode,
              businessCompanyName: this.userInfo.companyName,
            };
          }

          this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          // console.log(data.data, '部门信息');
          this.departmentList = data.data?.personDepartmentInfo;
          if (isFirst) {
            this.query = {
              ...this.query,
              businessDepartmentCode: this.userInfo?.departmentCode,
              businessDepartmentName: this.userInfo?.departmentName,
            };
            setTimeout(() => {
              this.getTableData();
            }, 10);
          }
        } else {
          console.error('获取部门失败');
        }
      },
      // 切换公司
      changeCompanyHandler(val) {
        // console.log(val, '切换公司');
        const item = this.companyList.find((item) => item.personCompanyCode == val);
        // console.log(item, '切换公司item');
        this.query = {
          ...this.query,
          businessDepartmentCode: '',
          businessDepartmentName: '',
          businessCompanyNo: val,
          businessCompanyName: item.personCompanyName ? item.personCompanyName : '',
        };
        // 获取部门数据
        this._getDepartmentByCompanyCodeApi(val);
      },
      // 切换部门
      changeDepartmentHandler(val) {
        // console.log(val, '切换部门');
        // console.log(this.departmentList, 'this.departmentList');

        const item = this.departmentList.find((item) => item.personDepartmentCode == val);
        this.query = {
          ...this.query,
          businessDepartmentCode: val,
          businessDepartmentName: item.personDepartmentName ? item.personDepartmentName : '',
        };
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      // 修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0]?.personNo || '';
      },
      // 切换供应商
      changeSupplyChainMethod(val) {
        this.query.supplierNo = val[0].partnerCode;
        console.log(val, '修改供应商');
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
